import { SaveTrees } from "@timesheets/constants-common";

export function getHelpUrl(_currentRole: unknown, route: string): string {
  return SaveTrees.Www.Help + "/" + route;
  //+ "#" + currentRole.type + "!" +
}
